import React from 'react'

import TextLink from 'Clutch/Atoms/TextLink'

const MarkdownLinks = ({ text, size = 1 }) => {
  // Regex to match [label](url)
  const regex = /\[([^\]]+)\]\(([^)]+)\)/g

  const parts = []
  let lastIndex = 0
  let match

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index))
    }

    parts.push(
      <TextLink intent={`action`} size={size} key={match.index} href={match[2]} targetBlank rel="noopener noreferrer">
        {match[1]}
      </TextLink>,
    )

    lastIndex = regex.lastIndex
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  return <>{parts}</>
}

export default MarkdownLinks
